// ADR-0125: the 0-point review-pattern Smokes ported from legacy's detectors,
// one per execution signal and one for long-term customers.
export enum ReviewPatternTypeKey {
  SALES_CONDUCT = "customer_sales_conduct_pattern",
  WORKMANSHIP = "customer_workmanship_pattern",
  VALUE = "customer_value_pattern",
  POST_SALE_SUPPORT = "customer_post_sale_support_pattern",
  PROJECT_MANAGEMENT = "customer_project_management_pattern",
  LONG_TERM_SATISFACTION = "customer_long_term_satisfaction_pattern",
}
